import { createContext } from "react";

export const DataContext = createContext(null);
export const TaskContext = createContext(null);
export const ImageContext = createContext(null);